import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "date-shortcuts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_shortcut_button = _resolveComponent("date-shortcut-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "shortcut-btn flex-center",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshShortcuts('back')))
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("div", { class: "chev-left" }, null, -1)
    ])),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateShortcuts, (date) => {
      return (_openBlock(), _createBlock(_component_date_shortcut_button, {
        key: date.date,
        shortcut: date,
        onOnSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selectDate', $event)))
      }, null, 8, ["shortcut"]))
    }), 128)),
    _createElementVNode("button", {
      class: "shortcut-btn flex-center",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshShortcuts('forward')))
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("div", { class: "chev-right" }, null, -1)
    ])),
    _createElementVNode("button", {
      id: "calBtn",
      class: "flex-center highlight-text",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggleCalendar'))),
      title: "Toggle Calendar"
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "20",
        viewBox: "0 0 24 24",
        width: "20",
        fill: "currentColor",
        stroke: "none"
      }, [
        _createElementVNode("path", { d: "M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 18H5c-.55 0-1-.45-1-1V8h16v12c0 .55-.45 1-1 1z" })
      ], -1)
    ]))
  ]))
}